import React from 'react'
// import  './Style.css'

export default function ShopBanner() {
    return (
        <section className="page-header" id="shop-header">
            <h2>#StayHome</h2>
            <p>Save more on coupons &amp; up to 70% off!</p>
        </section>
    )
}
